export type ProjectDocument = {
    key: string;
    label: string;
};

export const projectDocuments = [
    { key: "projectWeight", label: "Project Weight" },
    { key: "dataDestructionCertificate", label: "Cert of Data Destruction" },
    { key: "removalReceipt", label: "Removal Receipt" },
    { key: "environmentImpactReport", label: "Environment Impact Report" },
    { key: "settlementReport", label: "Settlement Report" },
    { key: "lockedLists", label: "Locked Lists" },
] as const satisfies ProjectDocument[];
